export function set(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch (ex) {
    // nothing to do
  }
}

export function get(key) {
  try {
    return Promise.resolve(localStorage.getItem(key))
  } catch (ex) {
    return Promise.resolve()
  }
}

export function remove(key) {
  try {
    return Promise.resolve(localStorage.removeItem(key))
  } catch (ex) {
    return Promise.resolve()
  }
}

export default {
  get,
  set,
  remove,
}
